import type { IconProps } from './types';

export function Kimono({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 44 Q92 40 108 44 Q118 84 128 128 Q138 84 148 44 Q164 40 180 44 Q204 52 232 68 Q232 116 232 148 Q232 156 224 156 L188 156 L188 208 Q188 216 180 216 L76 216 Q68 216 68 208 L68 156 L32 156 Q24 156 24 148 Q24 116 24 68 Q52 52 76 44 Z" />
      <path d="M72 152 Q128 156 184 152" />
    </svg>
  );
}
